const SET_LIST = 'set_list';

const BASE_ENDPOINT = '/report/company-report-customer-histories';

const state = () => ({
  list: [],
});

const actions = {
  fetch ({ commit }) {
    return this.$getDataProvider(BASE_ENDPOINT)
      .fetchAll('')
      .then((response) => {
        commit(SET_LIST, response.items);

        return response;
      });
  },
  // eslint-disable-next-line no-empty-pattern
  download ({}, report) {
    return this.$getDataProvider(BASE_ENDPOINT)
      .getFile('', {
        uuid: report.uuid,
        action: 'download',
      });
  },
};

const mutations = {
  [SET_LIST] (state, reports) {
    state.list = reports;
  },
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters,
};
